import '.eg{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.eh{padding-left:1.5rem;}.ssr-plugin'
import '.ei{margin:1rem 0;}.ssr-plugin'
import '.ej{color:var(--gray-700);}.ssr-plugin'
import '.ek{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="eg eh ei ej ek"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
